import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=5646ef90&scoped=true&"
import script from "./Canvas.vue?vue&type=script&lang=js&"
export * from "./Canvas.vue?vue&type=script&lang=js&"
import style0 from "./Canvas.vue?vue&type=style&index=0&id=5646ef90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646ef90",
  null
  
)

export default component.exports